import { Box, useTheme } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { PropsWithChildren } from 'react';
import PageWrapper from '../PageWrapper';

interface PageProps extends PropsWithChildren {
	sx?: SxProps;
	page?: string;
}

export const Page = ({ children, sx, page }: PageProps) => {
	const theme = useTheme();
	return (
		<PageWrapper page={page}>
			<Box
				sx={{
					backgroundColor: theme.palette.background.surface,
					display: 'flex',
					flexDirection: 'column',
					position: 'relative',
					paddingX: { xs: '5px', sm: '30px', lg: '60px' }
				}}
			>
				<Box
					sx={{
						zIndex: 1,
						flexGrow: 1,
						display: 'flex',
						flexDirection: 'column',
						marginY: '20px',
						marginX: 'auto',
						width: '100%',
						maxWidth: '1366px',
						...sx
					}}
				>
					{children}
				</Box>
			</Box>
		</PageWrapper>
	);
};
